import { getDefaultBrushAttribute, getDefaultBrushPoint } from '@meitu/saas-editor-core/es/layers/brush-layer';
import { BrushDasharrayType, BrushLinecapType } from '@meitu/saas-editor-core/es/version-types';

/**
 * 默认值通过产品文档设置
 * https://cf.meitu.com/confluence/pages/viewpage.action?pageId=435186937
 */
export const customConfig = {
    line: {
        color: '#000000',
        dasharray: BrushDasharrayType.Solid,
        linecap: BrushLinecapType.Square,
        width: 12,
        startPoint: getDefaultBrushPoint(),
        endPoint: getDefaultBrushPoint(),
    },
    curve: {
        fill: {
            ...getDefaultBrushAttribute(),
            color: '#ffffffff',
            width: 20,
            linecap: BrushLinecapType.Round,
            dasharray: BrushDasharrayType.Solid,
        },
        stroke: {
            ...getDefaultBrushAttribute(),
            color: '#000000ff',
            width: 6,
            linecap: BrushLinecapType.Round,
            dasharray: BrushDasharrayType.Solid,
        },
    },
};
